// eslint-disable-next-line import/order
import React, { lazy, Suspense, useState } from 'react';

const PnlShareModalFill = lazy(() => import('./PnlShareModalFill'));
const PnLShareModalPosition = lazy(() => import('./PnLShareModalPosition'));

import styled from 'styled-components';

import { ApiFill, ApiPosition } from 'api/types';
import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import { PNL_SHARE_ENABLED } from 'config/constants';

const OpenInNewIconStyled = styled(MaterialSymbol)`
  cursor: pointer;
  vertical-align: middle;
  margin-top: -2px;
  top: -2px;
`;

type Props = {
  market: string;
} & (
  | {
      fill: ApiFill;
      position?: undefined;
    }
  | {
      fill?: undefined;
      position: ApiPosition;
      // walletLeverage: string;
    }
);

export default function PnLShareShortcut({ market, fill, position }: Props) {
  const [open, setOpen] = useState(false);
  if (!PNL_SHARE_ENABLED) {
    return null;
  }
  if (fill?.action === 'open') {
    return null;
  }
  return (
    <>
      {' '}
      <OpenInNewIconStyled
        icon="open_in_new"
        fontSize="inherit"
        onClick={event => {
          event.stopPropagation();
          setOpen(true);
        }}
      />
      <div onClick={event => event.stopPropagation()}>
        <Suspense>
          {open &&
            (fill ? (
              <PnlShareModalFill
                onClose={() => setOpen(false)}
                market={market}
                fill={fill}
              />
            ) : position ? (
              <PnLShareModalPosition
                onClose={() => setOpen(false)}
                market={market}
                position={position}
              />
            ) : null)}
        </Suspense>
      </div>
    </>
  );
}
